import { useQuery } from '@tanstack/react-query';
import { clientFetch } from '~/lib/.client/fetch';
import { projectStore } from '~/lib/stores/project';
import { invariant } from '~/utils/invariant';
import type { PostgresTable } from '../lib/pg-meta/types';

const getFunctions = async (projectId?: string) => {
  try {
    invariant(projectId);

    const response = await clientFetch(`/api/supabase/projects/${projectId}/functions`);

    const result = await response.json<{ message: string } | PostgresTable[]>();

    if ('message' in result) {
      throw new Error(result.message);
    }

    return result;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : `${error}`);
  }
};

export const useGetFunctions = () => {
  const projectId = projectStore.projectId.get();

  return useQuery({
    queryKey: ['edge-functions', projectId],
    queryFn: () => getFunctions(projectId),
    enabled: !!projectId,
    retry: false,
  });
};
